export const PBConfigItemType = {
  HEADING: 'heading',
  TEMPLATE: 'template',
  GROUP: 'group',
  ARRAY: 'array',
  SIMPLE_FIELD: 'simpleField',
  FIELD: 'field',
} as const;

export interface BasePBConfigItem {
  id: string;
}

export interface PBHeadingConfig extends BasePBConfigItem {
  type: typeof PBConfigItemType.HEADING;
  value: string;
  level: number;
  path: string[];
  pathString: string;
}

export interface PBTemplateConfig extends BasePBConfigItem {
  type: typeof PBConfigItemType.TEMPLATE;
  value: string;
}

export interface PBGroupConfig<T> extends BasePBConfigItem {
  type: typeof PBConfigItemType.GROUP;
  groupId: string;
  fields: T[];
  path: string[];
  pathString: string;
}

export interface PBArrayConfig<T> extends BasePBConfigItem {
  type: typeof PBConfigItemType.ARRAY;
  arrayId: string;
  fields: T[];
  path: string[];
  pathString: string;
  typeOverride?: string;
  props?: Record<string, unknown>;
}

export interface PBFieldConfig<T> extends BasePBConfigItem {
  type: typeof PBConfigItemType.FIELD;
  field: T;
  path: string[];
  pathString: string;
}

export type PBConfigItem<T> =
  | PBHeadingConfig
  | PBTemplateConfig
  | PBGroupConfig<T>
  | PBArrayConfig<T>
  | PBFieldConfig<T>;
